export default "__VITE_ASSET__DfLr5vPX__"